const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
];

export const formatDate = str => {
  const date = new Date(str);
  return `${
    monthNames[date.getMonth()]
  }/${date.getDate()}/${date.getFullYear()}`;
};

export const formateDateTime = str => {
  const date = new Date(str);
  const hour = date.getUTCHours() === 12 ? 12 : date.getUTCHours() % 12;
  const amPm = ["AM", "PM"];
  return `${formatDate(str)} ${hour}:${date.getMinutes()} ${
    amPm[date.getUTCHours() >= 12 ? 1 : 0]
  }`;
};

export const currentYear = new Date().getFullYear();
export const yearList = new Array(currentYear - 2005 + 2)
  .fill(0)
  .map((_, idx) => 2005 + idx)
  .reverse();

export const currentMonth = new Date().getUTCMonth();
export const chapterYearList =
  currentMonth < 9
    ? [currentYear, currentYear - 1]
    : [currentYear + 1, currentYear, currentYear - 1];

export const twoDigit = value => (value < 10 ? `0${value}` : value);
export const asCurrency = value => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  });
  return formatter.format(value);
};
